import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetClustersNamesRequest = (userId, host) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GetClustersNames`,
	params: { userId, host },
});

export const GetSuperClustersRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GetSuperClusters`,
	params: { userId },
});

export const GetClusterDetailsRequest = (userId, clusterName, host) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GetClusterDetails`,
	params: { userId, clusterName, host },
});

export const GetVmo2ReportDatesRequest = (userId, clusterName, host) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GetVmo2ReportDates`,
	params: { userId },
});

export const GenerateReportRequest = (userId, searchType, clusterName, host, type, numberOfDays, mocnActivationDateA, benefit, exportCellsDetails, exportTopOffendersDetails) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GenerateReport`,
	params: { userId, searchType, clusterName, host, type, numberOfDays, mocnActivationDateA, benefit, exportCellsDetails, exportTopOffendersDetails },
	hasLoading: false
});

export const GenerateVmo2ReportRequest = (userId, workDate) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportsKpis/GenerateVmo2Report`,
	params: { userId, workDate },
	hasLoading: false
});

